<template>
    <div id="storybook-header">
      <CncIconButton :class="`mobile-nav-btn ${isOpenedNav ? 'is-opened' : ''}`" type="ghost" size="small" :iconName="{type: 'svg', name: 'IconMenu'}" @click="clickNav" />
        <a @click="navigateTo('/')" class="header-title">
          <svg id="header-logo" width="38" height="22" viewBox="0 0 38 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_34143_4332)">
            <path d="M26.072 7.86794C24.5451 7.46464 23.0028 7.60698 21.651 8.17469C19.7514 8.97302 18.2295 10.6121 17.6619 12.7566C16.8457 15.8396 14.0587 17.8776 11.01 17.8754C10.4291 17.8749 9.83931 17.8004 9.25121 17.6453C8.56703 17.4649 7.93365 17.1869 7.36322 16.8305C4.87112 15.2763 3.56846 12.2292 4.35867 9.2428C5.17428 6.15985 7.96181 4.12238 11.01 4.12404C11.5909 4.12459 12.1807 4.19907 12.7688 4.3541C13.4518 4.53451 14.0836 4.81147 14.6534 5.16677C14.6982 5.19436 14.7446 5.21973 14.7921 5.24401C14.807 5.25173 14.8219 5.25946 14.8373 5.26663C14.8429 5.26939 14.8478 5.27159 14.8533 5.27435C14.9677 5.32897 15.0875 5.37366 15.2117 5.40732C15.3073 5.43269 15.4061 5.4509 15.5066 5.46249C16.4117 5.57504 17.3366 5.11601 17.6978 4.24541C18.044 3.41012 17.7657 2.44739 17.1102 1.86754C17.1097 1.86699 17.1091 1.86644 17.108 1.86589C16.9827 1.75499 16.8435 1.65845 16.6922 1.57955C15.8192 1.05432 14.8594 0.641092 13.8251 0.367995C12.8847 0.119174 11.9405 0.000556186 11.0111 4.47609e-06C6.13346 -0.0044092 1.67384 3.25565 0.368427 8.18793C-0.896126 12.9663 1.18901 17.8418 5.17593 20.3283C6.08928 20.8982 7.10203 21.3424 8.19705 21.632C9.13746 21.8808 10.0817 21.9994 11.0111 22C13.9936 22.0017 16.8198 20.7835 18.864 18.709C19.758 19.8698 21.0287 20.7553 22.5555 21.1586C26.2288 22.1291 29.9943 19.9405 30.9656 16.2705C31.9364 12.6005 29.7458 8.8384 26.072 7.86794ZM26.9743 15.2167C26.5855 16.6848 25.0797 17.5604 23.6102 17.172C22.1408 16.7841 21.2645 15.2791 21.6532 13.811C22.042 12.3429 23.5478 11.4673 25.0173 11.8557C26.4867 12.2436 27.363 13.7481 26.9743 15.2167Z" fill="#FF2E38"/>
            <path d="M34.9532 19.4721C36.131 19.4721 37.0858 18.5181 37.0858 17.3414C37.0858 16.1646 36.131 15.2107 34.9532 15.2107C33.7754 15.2107 32.8206 16.1646 32.8206 17.3414C32.8206 18.5181 33.7754 19.4721 34.9532 19.4721Z" fill="#FF2E38"/>
            </g>
            <defs>
            <clipPath id="clip0_34143_4332">
            <rect width="37.0857" height="22" fill="white"/>
            </clipPath>
            </defs>
          </svg>
          <span class="header-text">Design system</span>
        </a>
        <ul class="header-nav">
          <a @click="navigateTo('/brand')"><li :class="currentMainMenu == 'brand' ? 'active' : '' ">Brand</li></a>
          <a @click="navigateTo('/foundations')"><li :class="currentMainMenu == 'foundations' ? 'active' : '' ">Foundations</li></a>
          <a @click="navigateTo('/components')"><li :class="currentMainMenu == 'components' ? 'active' : '' ">Components</li></a>
          <a @click="navigateTo('/resources')"><li :class="currentMainMenu == 'resources' ? 'active' : '' ">Resources</li></a>
          <a @click="navigateTo('/knowledges')"><li :class="currentMainMenu == 'knowledges' ? 'active' : '' ">Knowledges</li></a>
        </ul>
        <div class="header-nav-mob">
          <select class="header-nav-mob" onchange="navigateTo(this.value)">
            <option value="/" :selected="currentMainMenu == ''">Home</option>
            <option value="/brand" :selected="currentMainMenu == 'brand'">Brand</option>
            <option value="/foundations" :selected="currentMainMenu == 'foundations'">Foundations</option>
            <option value="/components" :selected="currentMainMenu == 'components'">Components</option>
            <option value="/resources" :selected="currentMainMenu == 'resources'">Resources</option>
            <option value="/knowledges" :selected="currentMainMenu == 'knowledges'">Knowledges</option>
          </select>
          <SvgIcon class="select-arrow" name="IconArrowChevronDown" :width="20"/>
        </div>
        <CncBadgeLabel class="version-badge" :label="$t('design_system_version')" size="medium" type="neutral"  styleBadge="minimal"></CncBadgeLabel>
    </div>
</template>

<script>

export default {
  data () {
    return {
      isOpenedNav: false
    }
  },
  computed: {
    currentMainMenu () {
      const mainMenu = this.$route.path.split('/').filter(Boolean)[0]
      // return mainMenu == undefined  ? '' : mainMenu ;
      return mainMenu == '' || mainMenu == undefined ? 'home' : mainMenu
    }
  },
  methods: {
    clickNav () {
      this.isOpenedNav = !this.isOpenedNav
      this.$emit('toggle-nav')
    },
    navigateTo (path) {
      window.location.href = path
    }
  }
}
</script>

<style lang="scss">

#storybook-header {
  display: flex;
  direction: row;
  gap: 24px;
  padding: 16px 20px;
  background-color: white;
  flex-grow: 0;
  border-bottom: solid 1px $color-cool-grey-100;
  align-items: center;

  @media screen and (max-width: 815px) {
    gap: 8px;
    padding: 12px 20px;
  }

  .mobile-nav-btn{
    margin-left: -6px ;
    display: none;

    svg path {
        fill: $color-cool-grey-500;
      }

    @media screen and (max-width: 815px) {
      display: block;
    }

    &.is-opened {
      background-color: $color-primary-50;

      svg path {
        fill: $color-primary-500;
      }

      &:hover {
      background-color: $color-primary-100;
      }
    }
  }

  .header-title {
    display: flex;
    direction: row;
    gap: 6px;
    align-items: center;
    flex: 0 0 auto;
    cursor: pointer;

    @media screen and (max-width: 815px) {
      gap: 4px;
    }

    #header-logo {
      position: relative;
      top: -2px;

      @media screen and (max-width: 815px) {
        width: 28px;
        top: -1px;
      }
    }

    .header-text {
      font: $font-style-title-lg-med;
    }
  }

  .header-nav {
    display: flex;
    flex-direction: row;
    gap: 24px;
    flex: 1 1 auto;
    margin: 0;
    padding: 0;
    list-style-type: none;

    @media screen and (max-width: 815px) {
      display: none;
    }

    a, li {
      cursor: pointer;
      font: $font-style-functional-lg-reg;
      color: $color-cool-grey-700;

      &:hover {
        color: $color-cool-grey-900;
      }

      &.active {
        color: $color-primary-500;
        font-weight: 500;

        &:hover {
          color: $color-primary-600;
        }
      }
    }
  }

  .header-nav-mob {
    position: relative;
    display: none;
    flex-grow: 1;
    text-align: right;

  @media screen and (max-width: 815px) {
      display: block;
    }

    select {
      display: inline-block;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      border: none;
      background: none;
      padding: 0;
      margin: 0;
      outline: none;
      width: auto;
      min-width: none;
      padding-right: 24px;
      font: $font-style-functional-lg-reg;
      color: $color-cool-grey-700;
      text-align: right;

      &:hover {
        color: $color-cool-grey-900;
      }
    }

    .select-arrow {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translate(0, -50%);
      pointer-events: none;
    }
  }

  .version-badge {
    @media screen and (max-width: 815px) {
        display: none;
      }
  }

}

</style>
